module.exports = __webpack_public_path__ + "img/info.345e34f8.svg";